module.exports = __webpack_public_path__ + "img/9788994965543.ea5f5ab1.jpg";